import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  // Scroll to top when page changes, handle hash navigation, and set title
  useEffect(() => {
    document.title = 'Prompt Airtime';
    if (currentPage.includes('#')) {
      const [page, hash] = currentPage.split('#');
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [currentPage]);
  const handleNavigate = (page: string) => {
    if (page.includes('#')) {
      const [basePage] = page.split('#');
      // If we're already on the page, just update the state to trigger the effect
      setCurrentPage(page);
    } else {
      setCurrentPage(page);
    }
  };
  const renderPage = () => {
    // Extract base page name if there's a hash
    const basePage = currentPage.split('#')[0];
    switch (basePage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} data-id="element-0" />;
      case 'about':
        return <AboutPage data-id="element-1" />;
      case 'services':
        return <ServicesPage onNavigate={handleNavigate} data-id="element-2" />;
      case 'contact':
        return <ContactPage data-id="element-3" />;
      default:
        return <HomePage onNavigate={handleNavigate} data-id="element-4" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans text-gray-900 bg-white" data-id="element-5">
      <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-6" />

      <main className="flex-grow" data-id="element-7">{renderPage()}</main>

      <Footer onNavigate={handleNavigate} data-id="element-8" />
    </div>;
}